export default __webpack_public_path__ + "static/media/box3.17743554.png";